
import { Vue } from "vue-class-component";

export default class BadgeFailed extends Vue {}
